
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import componentTitle from './componentTitle.vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router"
    import utils from '@/util/index';
    interface State {
        queryModules: object[];
    }
    export default defineComponent({
        name: 'entrustQuery',
        setup() {
            let state: State = reactive({
                queryModules: []
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo,(data: any) => {
                const {queryModules} = data;
                state.queryModules = queryModules || [];
            })
            function haveScore(item: any): boolean {
                if(item && item.score && item.score.length > 0){
                    return true;
                }else {
                    return false;
                }
            }
            function changeLevelClass(item: any): string {
                if (item && item.level === 'lev1') {
                    return 'entrustQueryLevel level1';
                } else if (item && item.level === 'lev2') {
                    return 'entrustQueryLevel level2';
                } else if (item && item.level === 'lev3') {
                    return 'entrustQueryLevel level3';
                }else if (item && item.level === 'lev4') {
                    return 'entrustQueryLevel level4';
                } else {
                    return 'entrustQueryLevel';
                }
            }
            function getLevelDes(item: any): any {
                if (!item.score) {
                    return {
                        level: '',
                        txt: ''
                    };
                }
                let num = Number(item.score)*10;
                if (num <=100 && num >=90) {
                    return {
                        level: 'lev1',
                        txt: '评级极好'
                    };
                } else if (num <90 && num >=75) {
                    return {
                        level: 'lev2',
                        txt: '评级优秀'
                    };
                } else if (num <75 && num >=60) {
                    return {
                        level: 'lev3',
                        txt: '评级一般'
                    };
                } else if (num < 60) {
                    return {
                        level: 'lev4',
                        txt: '评级较差'
                    };
                }
            }
            function getScoreDes(item: any): string {
                if (item && item.score && item.score.length > 0) {
                    return item.score + '分';
                } else  {
                    return '查看查询报告';
                } 
            }
            return {
                state,
                haveScore,
                changeLevelClass,
                getLevelDes,
                getScoreDes,
            }
        },
        methods: {
            goToView (item: any) {
                window.location.href=(item && item.reportUrl) || '';
            }
        },
        components: {
            componentTitle
        },
        
    })
